import { Box, Typography, Paper } from "@mui/material";
import { TableHeaderContainer } from "../components/container/TableHeaderContainer";
import { TableTitleContainer } from "../components/container/TableTitleContainer";
import mime from "mime";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { FiBookOpen, FiClipboard, FiClock, FiFile, FiMapPin } from "react-icons/fi";
import FileUpload from "../components/input/FileUpload";
import ImageUpload from "../components/input/ImageUpload";
import ResizableTextBox from "../components/input/ResizableTextBox";
import SelectBox from "../components/input/SelectBox";
import TextBox from "../components/input/TextBox";
import { useContextProvider } from "../components/page-context/ContextProvider";
// import { uniformat_II } from "../components/Uniformat_II";
import { Product } from "../db_access/product";
import { getOrgTokens, ORG_PALETTE } from "../theme/style/organizationPalette";
import { useTheme } from "@mui/material";

const ProductInfo = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";
  const tok = getOrgTokens(isDark);
  const { isSaveClicked, setIsSaveVisible, setIsSaveClicked, setIsLoading, selectedProductIds } = useContextProvider();
  const { setRefresh } = useContextProvider();
  const [formData, setFormData] = useState({
    assumptions: "",
    extended_service_life: 0,
    intro: "",
    isEpd: false,
    place_of_manufacture: "",
    place_of_use: "",
    service_life: 0,
    specifications: "",
    uniformat_II_1: null,
    uniformat_II_2: null,
    uuid: "",
  });
  const [photo, setPhoto] = useState();
  const [photoPreview, setPhotoPreview] = useState();

  const [specDocument, setSpecDocument] = useState();
  const [specDocumentPreview, setSpecDocumentPreview] = useState();

  const [safetyDocument, setSafetyDocument] = useState();
  const [safetyDocumentPreview, setSafetyDocumentPreview] = useState();

  const [modified, setModified] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState();
  const ref = useRef(null);

  useEffect(() => {
    if (selectedProductIds.length < 1) {
      setSelectedProduct(undefined);
    } else {
      Product.get_by_id(selectedProductIds[0])
        .then((res) => res.json())
        .then((data) => {
          setSelectedProduct(data[0]);
        });
    }
  }, [selectedProductIds]);
  useEffect(() => {
    if (selectedProduct) {
      const isEpdValue = selectedProduct?.is_epd === 1;
      setFormData((prev) => ({
        ...prev,
        intro: selectedProduct?.intro || "",
        specifications: selectedProduct?.specifications || "",
        place_of_manufacture: selectedProduct?.place_of_manufacture || "",
        place_of_use: selectedProduct?.place_of_use || "",
        uuid: selectedProduct?.uuid || "",
        service_life: selectedProduct?.service_life || 0,
        extended_service_life: selectedProduct?.extended_service_life || 0,
        uniformat_II_1: selectedProduct?.uniformat_II_1 || null,
        uniformat_II_2: selectedProduct?.uniformat_II_2 || null,
        isEpd: isEpdValue,
      }));
    }
    setModified(false);
  }, [selectedProduct]);

  const handleChange = (field) => (e) => {
    if (formData.isEpd) return;
    const value = field === "is_reusable" || field === "isEpd" ? e.target.checked : e.target.value;
    setFormData({ ...formData, [field]: value });
    setIsSaveVisible(true);
    setModified(true);
  };
  // const handleSelectBoxChange = (field) => (e, newValue) => {
  //   setFormData({ ...formData, [field]: newValue ? newValue.value : null });
  //   setIsSaveVisible(true);
  //   setModified(true);
  // };

  const handlePhotoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setPhoto(file);
    } else {
      setPhoto(undefined);
    }
    setIsSaveVisible(true);
    setModified(true);
  };

  const handleSpecDocumentChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSpecDocument(file);
    } else {
      setSpecDocument(undefined);
    }
    setIsSaveVisible(true);
    setModified(true);
  };

  const handleSafetyDocumentChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSafetyDocument(file);
    } else {
      setSafetyDocument(undefined);
    }
    setIsSaveVisible(true);
    setModified(true);
  };

  useEffect(() => {
    if (photo) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPhotoPreview(reader.result);
      };
      reader.readAsDataURL(photo);
    } else {
      setPhotoPreview(undefined);
    }
  }, [photo]);
  useEffect(() => {
    if (specDocument) {
      setSpecDocumentPreview("spec_document." + mime.getExtension(specDocument.type));
    } else {
      setSpecDocumentPreview(undefined);
    }
  }, [specDocument]);
  useEffect(() => {
    if (safetyDocument) {
      setSafetyDocumentPreview("safety_document." + mime.getExtension(safetyDocument.type));
    } else {
      setSafetyDocumentPreview(undefined);
    }
  }, [safetyDocument]);

  useEffect(() => {
    if (selectedProduct && selectedProduct?.id) {
      const request = Product.get_photo(selectedProduct?.id);
      request
        .then((res) => {
          if (res.ok) {
            return res.blob();
          } else {
            return undefined;
          }
        })
        .then((j) => {
          setPhoto(j);
        });
    } else {
      setPhoto(undefined);
    }
  }, [selectedProduct]);

  useEffect(() => {
    if (selectedProduct && selectedProduct?.id) {
      const request = Product.get_spec_document(selectedProduct?.id);
      request
        .then((res) => {
          if (res.ok) {
            return res.blob();
          } else {
            return undefined;
          }
        })
        .then((j) => {
          setSpecDocument(j);
        });
    } else {
      setSpecDocument(undefined);
    }
  }, [selectedProduct]);

  useEffect(() => {
    if (selectedProduct && selectedProduct?.id) {
      const request = Product.get_safety_document(selectedProduct?.id);
      request
        .then((res) => {
          if (res.ok) {
            return res.blob();
          } else {
            return undefined;
          }
        })
        .then((j) => {
          setSafetyDocument(j);
        });
    } else {
      setSafetyDocument(undefined);
    }
  }, [selectedProduct]);

  useEffect(() => {
    if (isSaveClicked && modified) {
      const fd = new FormData();
      Object.keys(formData).forEach((k) => {
        fd.append(k, formData[k]);
      });
      fd.append("id", selectedProduct?.id);
      fd.append("photo", photo);
      fd.append("specDocument", specDocument);
      fd.append("safetyDocument", safetyDocument);
      Product.save_product_info(fd)
        .catch((err) => {
          console.error("Error:", err);
        })
        .finally((_) => {
          setModified(false);
          setIsSaveClicked(false);
          setIsLoading(false);
          setRefresh((r) => !r);
        });
    }
  }, [isSaveClicked, modified]);

  return (
    <Paper variant="Table Container">
      <TableHeaderContainer>
        <TableTitleContainer>
          <Typography variant="Table Title">{t("Product Info")}</Typography>
        </TableTitleContainer>
      </TableHeaderContainer>
      <Box sx={{ p: 3 }}>
        <Box sx={{ display: "flex", gap: 3, flexDirection: { xs: "column", md: "row" } }} ref={ref}>
          {/* LEFT COLUMN: Input Fields */}
          <Box sx={{ flex: 2, display: "flex", flexDirection: "column", gap: 3 }}>
            <ResizableTextBox
              Icon={FiBookOpen}
              label={"Product Introduction"}
              placeholder={"Brief introduction"}
              value={formData.intro}
              onChange={handleChange("intro")}
              disabled={formData.isEpd}
            />
            <ResizableTextBox
              Icon={FiClipboard}
              label={"Specifications"}
              placeholder={"Enter specifications"}
              value={formData.specifications}
              onChange={handleChange("specifications")}
              disabled={formData.isEpd}
            />
            <TextBox
              Icon={FiClipboard}
              label={"Product UUID"}
              placeholder={"Product UUID"}
              value={formData.uuid}
              onChange={handleChange("uuid")}
              disabled={formData.isEpd}
            />
            <TextBox
              Icon={FiClock}
              label={"Service Life (years)"}
              placeholder={"Years"}
              value={formData.service_life}
              onChange={handleChange("service_life")}
              disabled={formData.isEpd}
            />
            <TextBox
              Icon={FiClock}
              label={"Extended Service Life (years)"}
              placeholder={"Years"}
              value={formData.extended_service_life}
              onChange={handleChange("extended_service_life")}
              disabled={formData.isEpd}
            />
            <Box sx={{ display: "flex", gap: 3 }}>
              <Box sx={{ flex: 1 }}>
                <TextBox
                  Icon={FiMapPin}
                  label={"Place of Manufacture"}
                  placeholder="Place of Manufacture"
                  value={formData.place_of_manufacture}
                  onChange={handleChange("place_of_manufacture")}
                  disabled={formData.isEpd}
                />
              </Box>
              <Box sx={{ flex: 1 }}>
                <TextBox
                  Icon={FiMapPin}
                  label={"Place of Use"}
                  placeholder="Place of Use"
                  value={formData.place_of_use}
                  onChange={handleChange("place_of_use")}
                  disabled={formData.isEpd}
                />
              </Box>
            </Box>
            {/* UNIFORMAT II Level 1 & 2 hidden for now
            <Box sx={{ display: "flex", gap: 3 }}>
              <Box sx={{ flex: 1 }}>
                <SelectBox
                  Icon={FiMapPin}
                  label={"UNIFORMAT II Level 1"}
                  placeholder="UNIFORMAT II Level 1"
                  value={formData.uniformat_II_1 || null}
                  options={uniformat_II}
                  onChange={handleSelectBoxChange("uniformat_II_1")}
                  disabled={formData.isEpd}
                />
              </Box>
              <Box sx={{ flex: 1 }}>
                <SelectBox
                  Icon={FiMapPin}
                  label={"UNIFORMAT II Level 2"}
                  placeholder="UNIFORMAT II Level 2"
                  value={formData.uniformat_II_2 || null}
                  options={uniformat_II.find((u) => u.value === formData.uniformat_II_1)?.subLevels || []}
                  onChange={handleSelectBoxChange("uniformat_II_2")}
                  disabled={formData.isEpd}
                />
              </Box>
            </Box>
            */}
          </Box>

          {/* RIGHT COLUMN: Media & Documents */}
          <Box sx={{ flex: 1, maxWidth: { md: 400 }, width: "100%", display: "flex", flexDirection: "column", gap: 3 }}>
            <ImageUpload
              Icon={FiFile}
              label={"Product Photo"}
              placeholder={"Click to upload photo"}
              onChange={handlePhotoChange}
              disabled={formData.isEpd}
              preview={photoPreview}
              alt={"Product"}
              accept={"image/*"}
              deletePreview={() => {
                setPhoto(undefined);
                setIsSaveVisible(true);
                setModified(true);
              }}
            />
            <FileUpload
              Icon={FiFile}
              label={"Specification Document"}
              preview={specDocumentPreview}
              placeholder={"Click to upload document"}
              onChange={handleSpecDocumentChange}
              disabled={formData.isEpd}
              accept={".pdf,.doc,.docx"}
              deletePreview={() => {
                setSpecDocument(undefined);
                setIsSaveVisible(true);
                setModified(true);
              }}
              file={specDocument}
            />
            <FileUpload
              Icon={FiFile}
              label={"Product Safety"}
              preview={safetyDocumentPreview}
              placeholder={"Click to upload document"}
              onChange={handleSafetyDocumentChange}
              disabled={formData.isEpd}
              accept={".pdf,.doc,.docx"}
              deletePreview={() => {
                setSafetyDocument(undefined);
                setIsSaveVisible(true);
                setModified(true);
              }}
              file={safetyDocument}
            />
          </Box>
        </Box>
      </Box>
    </Paper>
  );
};

export default ProductInfo;
